<template>
  <div class="group-item" :key="refresh_key">
    <div class="group-view" v-if="mode === 'view'">
      <el-row>
        <el-col :span="14">
          <slot name="checkbox">
            <span class="group-name">
<!--              <i class="el-icon-rank" style="font-size: 20px;vertical-align: middle;margin-top: -1px"></i>-->
              {{ groupData.name }}
            </span>
          </slot>
        </el-col>
        <el-col :span="7">
          <slot>
            <span class="group-name">
              <span v-if="groupData.visible === 'individual'">
               <i class="el-icon-lock"></i> {{$t('shopgroupitem.personal_group_name')}}
              </span>
              <span v-if="groupData.visible === 'team'">
                {{$t('shopgroupitem.team_group_name')}}
              </span>
            </span>
          </slot>
        </el-col>
        <el-col :span="3">
          <slot>
            <span class="group-name">
              {{ groupData.quantity }}
            </span>
          </slot>
        </el-col>
      </el-row>
      <span class="group-options">
        <el-button size="small" type="text" @click="setMode('edit')">
          <i class="fas fa-pen"></i>
        </el-button>
        <el-button size="small" type="text" @click="deleteGroup">
          <i class="far fa-trash-alt"></i>
        </el-button>
      </span>
    </div>
    <div class="group-view" v-if="mode === 'edit'">
      <el-row>
        <el-col :span="14">
          <span>
            <el-input
              size="small"
              maxlength="30"
              :autofocus="true"
              ref="group_name"
              v-model="name"
              class="group-input"
            ></el-input>
          </span>
        </el-col>
        <el-col :span="7">
          <el-select v-model="visible" size="small">
            <el-option v-for="item in selectedList" :key="item.value" :label="item.label" :value="item.value">
              <span >{{ item.label }}<question :content="item.tips"></question></span>
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <slot>
            <span class="group-name">
              {{ groupData.quantity }}
            </span>
          </slot>
        </el-col>
      </el-row>

      <span class="group-options">
        <el-button size="small" type="text" @click="save">
          <i class="fas fa-check"></i>
        </el-button>
        <el-button size="small" type="text" @click="setMode('view')">
          <i class="fas fa-times"></i>
        </el-button>
      </span>
    </div>
    <div class="group-view" v-if="mode === 'add'">
      <el-row>
        <el-col :span="14">
          <span>
            <el-input
              size="small"
              maxlength="30"
              :autofocus="true"
              ref="group_name"
              v-model="name"
              class="group-input"
            ></el-input>
          </span>
        </el-col> 
        <el-col :span="7">
          <el-select v-model="visible" size="small" >
              <el-option v-for="item in selectedList" :key="item.value" :label="item.label" :value="item.value">
                <span >{{ item.label }}<question :content="item.tips"></question></span>
              </el-option>
          </el-select>
        </el-col>
      </el-row>
      <span class="group-options">
        <el-button size="small" type="text" @click="add">
          <i class="fas fa-check"></i>
        </el-button>
        <el-button size="small" type="text" @click="setMode('add-btn')">
          <i class="fas fa-times"></i>
        </el-button>
      </span>
    </div>
    <div class="group-view all" v-if="mode === 'add-btn'">
      <el-button
        size="small"
        type="text"
        class="group-add"
        slot="reference"
        @click="setMode('add')"
      >
      <i class="el-icon-circle-plus c1fc969"></i>
        {{ $t("vdgroupitem.add_group") }}
      </el-button>
    </div>
  </div>
</template>
<script>
const UUID = require("uuid");
import { GroupModel,GroupProModel } from "@/models/groups.model";
import API from "@ym-framework/api-utils";
import _ from "lodash";
import Question from "@/components/Question.vue";
export default {
  name: "VdGroupItem",
  components:{
    Question
  },
  props: {
    initMode: {
      default() {
        return "view";
      },
    },
    group: {
      default() {
        return new GroupProModel();
      },
    },
  },
  data() {
    return {
      refresh_key: UUID.v4(),
      groupData: this.group,
      name: this.group.name,
      visible:this.group.visible,
      mode: this.initMode,
      selectedList:[
        {
          label:this.$t('shopgroupitem.team_group'),
          value:"team",
          tips:this.$t('shopgroupitem.team_group_tips')
        },
        {
          label:this.$t('shopgroupitem.personal_group'),
          value:"individual",
          tips:this.$t('shopgroupitem.personal_group_tips')
        }
      ]
      // groups : new GroupsClass(),
    };
  },
  methods: {
    refresh() {
      this.refresh_key = UUID.v4();
      this.name = this.group.name;
    },
    setMode(mode) {
      this.mode = mode;
      this.$emit('changeMode',this.mode)
      this.refresh();
    },
    async deleteGroup() {
      await this.$confirm(
        this.$t("vdgroupitem.sure_to_delete_group"),
        this.$t("vdgroupitem.warning"),
        {
          customClass: "confirm-dark",
          confirmButtonText: this.$t("vdgroupitem.delete"),
          cancelButtonText: this.$t("vdgroupitem.cancel"),
          confirmButtonClass: "btn-orange",
          cancelButtonClass: "btn-dark",
          roundButton: true,
        }
      );
      // let response = await API.delete(
      //   `api://base.auth/api/v7/groups/${this.groupData.id}`
      // );
      // base.auth.pro
      // 删除分组
      await API.delete(
        `api://base.auth.pro/v1/groups/${this.groupData.id}`
      )
      this.$emit("refresh");
    },
    add:_.debounce(async function(){
      let that = this;
       try {
        if (that.name === null || that.name === "") {
          return that.$message.error(that.$t("vdgroupitem.group_cant_null"));
        }
        // let response = await API.post(`api://base.auth/api/v7/groups`, {
        //   name: that.name,
        //   visible:that.visible
        // });
        // base.auth.pro
        // 创建分组
        await API.post(`api://base.auth.pro/v1/groups`,{
          name:that.name,
          visible:that.visible,
          type:'VD'
        })
        that.setMode("add-btn");
        that.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          that.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    },400),
    save:_.debounce(async function(){
      let that = this;
      try {
        // let response = await API.put(
        //   `api://base.auth/api/v7/groups/${that.groupData.id}`,
        //   {
        //     name: that.name,
        //     visible:that.visible
        //   }
        // );
        // base.auth.pro
        // 编辑分组
        await API.put(`api://base.auth.pro/v1/groups/${that.groupData.id}`,
          {
            name:that.name,
            visible:that.visible,
            type:'VD'
          }
        )
        that.setMode("view");
        that.$emit("refresh");
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          that.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    },400)
  },
};
</script>
<style scoped lang="scss">
.group-add {
  margin: auto;
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
}
.group-input {
  // /deep/.el-input__inner{
  //     height: 20px;
  // }
}
.group-item {
  position: relative;
  padding: 0 80px 0 0;
  margin: 10px 0;
  border-radius: 20px;
  background-color: #ecedf0;
  /*border: 1px solid #293e4b;*/
  color: #000;
}
.group-view {
  height: 34px;
  text-align: left;
  &.all {
    margin-right: -80px;
  }
  .group-name {
    display: inline-block;
    padding: 0 10px;
    line-height: 34px;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .group-add{
    &.el-button--text {
      padding: 5px 0;
      :deep(span){
        // display: flex;
        align-items: center;
        padding: 4px 8px;
        font-size: 13px;
        border: 1px dashed #1ed26c;
        border-radius: 30px;
      }
    }
  }
  .c1fc969 {
    margin-right: 2px;
    font-size: 20px;
    color: #1fc969;
    position: relative;
    top: 2px;
  }
  .group-options {
    position: absolute;
    top: -1px;
    right: 15px;
  }
  .group-input {
    input {
      border-radius: 20px;
    }
  }
}
</style>